/**
 * Badge constants for both user-specific and site-level badges.
 */

// USER-SPECIFIC BADGES
/**
 * User-specific badge type constants.
 * These values are stored in the database and displayed to end users.
 * User-specific badges are assigned to individual users (isUserSpecific: true).
 */
export const USER_BADGE_TYPES = {
  CONTRIBUTOR: "Contributor",
  ARTIST: "Artist",
} as const;

/**
 * User badge options for dropdowns/selects.
 * Each option has a value (stored in DB) and a label (displayed in UI).
 */
export const USER_BADGE_OPTIONS = [
  { value: "", label: "No Badge" },
  { value: USER_BADGE_TYPES.CONTRIBUTOR, label: "Contributor" },
  { value: USER_BADGE_TYPES.ARTIST, label: "Artist" },
] as const;

// SITE-LEVEL BADGES

/**
 * Site-level badge type constants.
 * These values are stored in the database and applied to all users on a site
 * during the specified date range (isUserSpecific: false).
 */
export const SITE_BADGE_TYPES = {
  DAY_ONE: "Day One",
  SUPERFANS: "Superfans",
} as const;

/**
 * Site-level badge options for dropdowns/selects.
 * Each option has a value (stored in DB) and a label (displayed in UI).
 */
export const SITE_BADGE_OPTIONS = [
  { value: SITE_BADGE_TYPES.DAY_ONE, label: "Day One" },
  { value: SITE_BADGE_TYPES.SUPERFANS, label: "Superfans" },
] as const;
